import user from 'js/lib/user';

import { UserPreferenceKeys } from 'bundles/common/constants/UserPreferences';

import NaptimeResource from './NaptimeResource';

const makeKeyForUser = (key: string) => user.get().id + '~' + key;

type Preference = {
  definition: Record<string, any>;
};

class UserPreferences extends NaptimeResource {
  declare preference?: Preference;

  static RESOURCE_NAME = 'userPreferences.v1';

  static keys = UserPreferenceKeys;

  static me(key: string) {
    return this.get(makeKeyForUser(key), {}, (preferences) => preferences || {});
  }

  static updatePreference(key: string, definition: Object) {
    const data = {
      preference: {
        typeName: key,
        definition,
      },
    };
    return this.update(makeKeyForUser(key), data);
  }
}

export default UserPreferences;
